import React, { useEffect } from "react";

import Header from "../components/Header/Header";
import HeroSection from "../components/Product-ExamOnline/HeroSection";
import Content from "../components/Product-ExamOnline/Content";
import Footer from "../components/Footer/Footer";

const ProductExamOnline = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <HeroSection />
      <Content />
      <Footer />
    </>
  );
};

export default ProductExamOnline;
